import React, {useEffect, useState} from "react";
import { Link as LinkScroll } from "react-scroll";
import Link from "next/link";
import queryString from "query-string";
import { Sales } from "../../views/Home/Sales";
import ProductDescriptionWidget from "../ProductDescriptionWidget";
import { dataSourceV2 } from "commons-ui/core/DataSource";
import Loading from "commons-ui/core/Loading";
import { useStore } from "../../context/state";
import { useRouter } from "../../hooks/useRouter";

import Button from "@material-ui/core/Button";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";

export const Menu = ({
  filters,
  locationId,
  locationParentId,
  deliveryItem,
  dateSelected,
  isDisabled,
  requestedDate
}) => {
  const { isMobile, ecommerceStoreId, cart, dispatch, apiPath, mediaPath } = useStore();
  const [categoryList, setCategoryList] = useState([]);
  const [selected, setSelected] = useState({});
  const [productDictByCategory, setProductDictByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  //const location = useRouter();


  const onItemClick = (id, ref, item, isDetails, featureList) => {
      if (!isDetails && Object.keys(item).filter(v => v.includes("__json")).length && !featureList) {
          isDetails = true
      }
      if (isDetails) {
          //console.log(123, location.pathname + "?" + queryString.stringify({...filters, show_product: id}))
          //dispatch(location.pathname + "?" + queryString.stringify({...filters, show_product: id}));
          setSelected(item)
      } else {
          const onAddToCart = (reset) => dispatch("cart", { product: item, count: 1, ecommerceStoreId, deliveryItem, reset, featureList}, "add_product");
          if (deliveryItem.name !== cart.deliveryItem.name && (cart.items || []).length !== 0) {
              dispatch("dialog_core", {option: {action: ()=>onAddToCart(true)}, isOpen: true, type: "CART_RESET"});
          } else {
            onAddToCart();
          }
      }
  };

  const requestProductList = async (category) => {
    const query = {
      size: 100,
      sort: [],
      _source: ["search_result_data"],
      query: {
        bool: {
          must: [],
          filter: [
            { term: { "search_data.ecommerce_store_id": ecommerceStoreId } },
          ],
          //filter: [{ term: { "category.id_list": category } }],
          must_not: [{ term: { "hidden.id_list": "default" } }, { terms: { "inventory_hidden.id_list": locationParentId ? [locationId, locationParentId] : [locationId] } }],
        },
      },
    };

    return dataSourceV2(
      `ecommerce_product_view_list?is_search=true&postprocess=${locationId}&query=${JSON.stringify(
        query
      )}`,
      { url: apiPath }
    ).then((v) => {
      if (!v.message && v.item_list) {
        let itemList = v.item_list.map((data) => {
          const category_id_dict = data.category_id_dict || {};
          const version = data.version || {};

          return {
            ...version,
            category_id_dict,
            attribute_set_id: data.attribute_set_id,
            ecommerce_product_id: data.ecommerce_product_id,
          };
        });
        itemList = itemList.filter(item => {
            // Filter Unavailable Products from Menu
            if (dateSelected && item.product_available_from && item.product_available_till) {
                const fromDate = new Date(item.product_available_from);
                fromDate.setHours(0, 1);
                const tillDate = new Date(item.product_available_till);
                tillDate.setHours(23, 59);
                const date = new Date(dateSelected);
                date.setHours(12);
                if (date < fromDate || date > tillDate) {
                    return false;
                }
            }
            return true;
        });
        return itemList;
      }
      return [];
    });
  };

  const requestCategoryList = async () => {
      const categoryListResponse = await dataSourceV2(
        `ecommerce_product_category_list?ecommerce_store_id=${ecommerceStoreId}`,
        { url: apiPath }
      );

      const categoryList = (categoryListResponse.item_list || []).filter(
        (category) => {
          return (
            !category.is_hidden &&
            (!category.type ||
              category.type === "primary" ||
              category.type === "preview")
          );
        }
      );

      const productList = await requestProductList();
      const productDictByCategory = {};

      console.log(categoryListResponse, ecommerceStoreId, categoryList, productList);

      for (let i = 0; i < categoryList.length; i++) {
        const categoryId = categoryList[i].ecommerce_product_category_id;

        const productListFiltered = productList.filter(v => {
            return !!(v.category_id_dict || {})[categoryId];
        });
        productDictByCategory[categoryId] = productListFiltered;
      }

      console.log(categoryList, productDictByCategory)

      if (true) {
        const giftCardCategory = {
          name: "GIFT CARDS",
          ecommerce_product_category_id: "__gift_card_category"
        };
        categoryList.push(giftCardCategory);
        const products = [
          {name: "eGift Card", price: 10, price_prefix: "from", redirect: "/gift-card-order", images: "/static/img/egift_card.png"},
          {name: "Plastic Gift Card", price: 10, price_prefix: "from", redirect: "/gift-card-order?gift_card_type=plastic", images: "/static/img/gift_card.png"}
        ];
        productDictByCategory["__gift_card_category"] = products;
      }

      setCategoryList(categoryList);
      setProductDictByCategory(productDictByCategory);
      setLoading(false);
      //console.log(123, categoryList, productDictByCategory);
  };

  useEffect(() => {
      if (locationId) requestCategoryList();
  }, [locationId]);



  let content = (
    <>
      {categoryList.map((category, i) => {
        const id = category.ecommerce_product_category_id;
        const name = category.name;

        let productList = productDictByCategory[category.ecommerce_product_category_id] || [];
        if (requestedDate) {
          const requestedDateObj = new Date(requestedDate);
          productList = productList.filter(product => {
            const productAvailableFrom = product.product_available_from;
            const productAvailableTill = product.product_available_till;
            if (productAvailableFrom && productAvailableTill) {
              const productAvailableFromObj = new Date(productAvailableFrom);
              const productAvailableTillObj = new Date(productAvailableTill);
              if (requestedDateObj >= productAvailableFromObj && requestedDateObj <= productAvailableTillObj) {
                return true
              } else {
                return false
              }
            }
            return true
          })
        }

        if (productList.length === 0) {
          return null;
        }
        
        console.log(12, productList)
        return (
          <Sales
              key={i}
            category={id}
            columns={3}
            filters={filters}
            size={20}
            itemId="ecommerce_product_id"
            labelClassName=""
            deliveryItem={deliveryItem}
            onItemClick={onItemClick}
            isDisabled={isDisabled}
            label={
                <div className={
                  isMobile
                    ? "u-absolute u-top0 u-sizeFullWidth u-flexCenter u-justifyContentCenter"
                    : "u-marginBottom20"
                }
              >
                <div
                  id={id}
                  className="u-textColorPrimary u-paddingHorizontal20 u-paddingVertical5 u-xs-textAlignCenter"
                  style={{ fontFamily: "Piroshky", letterSpacing: "2px", fontSize: "30px" }}
                >
                  {name}
                </div>
                </div>
            }
            productList={productList}
          />
        );
      })}
    </>
  );

  return (
    <div className="menu-page product-list-page background-wrapper rocket-layout">

        <div className="u-marginTop50 u-flexCenter u-justifyContentCenter">
            <div
              className="u-textColorPrimary u-paddingHorizontal20 u-paddingVertical5 u-xs-textAlignCenter"
              style={{ fontFamily: "Piroshky", letterSpacing: "2px", fontSize: "30px" }}
            >
              Menu
            </div>
        </div>
        {
            loading ?
                <Loading/>
                :
                null
        }
        <div className="u-marginTop30 u-xs-marginTop30 u-flexCenter u-flexWrap">
          {categoryList.map((category, i) => {
            const id = category.ecommerce_product_category_id;
            const name = category.name;
            return (
              <LinkScroll
                key={i}
                activeClass="active"
                to={id}
                spy={true}
                smooth={true}
                role="button"
                offset={-20}
                className="u-border1 u-borderColorLighter u-backgroundColorWhite u-textColorDark u-borderRadius30 u-paddingHorizontal12 u-paddingVertical5 u-marginBottom10 u-marginRight10 u-cursorPointer"
                duration={500}
              >
                <span>{name}</span>
              </LinkScroll>
            );
          })}
        </div>
        <div className="u-marginTop20 u-xs-marginTop30" style={{marginLeft: isMobile ? -9 : undefined, marginRight: isMobile ? -9 : undefined}}>{content}</div>

        <ProductDescriptionWidget
          ecommerceStoreId={ecommerceStoreId}
          cart={cart}
          apiPath={apiPath}
          mediaPath={mediaPath}
          dispatch={dispatch}
          location={location}
          open={!!selected["ecommerce_product_id"]}
          productId={selected["ecommerce_product_id"]}
          onClose={() => setSelected({})}
          onAddToCart={(featureList) => onItemClick(selected["ecommerce_product_id"], undefined, selected, false, featureList)}
          isFullscreen={isMobile}
        />
    </div>
  );
};
